import { render, staticRenderFns } from "./RadioTopics.vue?vue&type=template&id=4198a118&scoped=true&"
import script from "./RadioTopics.vue?vue&type=script&lang=js&"
export * from "./RadioTopics.vue?vue&type=script&lang=js&"
import style0 from "./RadioTopics.vue?vue&type=style&index=0&id=4198a118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4198a118",
  null
  
)

export default component.exports